import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./profile.css";

import { getAccountLinks } from "../../pages/api/accountLinksApi.js";
import { getProfile } from "../../pages/api/profileApi.js";

export default function Profile() {
const [userData, setUserData] = useState(null);

const [accountLinks, setAccountLinks] = useState({
discord: "",
youtube: "",
website: "",
});

const [loading, setLoading] = useState(true);
const [loadingLinks, setLoadingLinks] = useState(true);

useEffect(() => {
loadProfile();
}, []);

const loadProfile = async () => {
try {
const storedUser = localStorage.getItem("user");


  if (!storedUser) {
    setLoading(false);
    setLoadingLinks(false);
    return;
  }

  const parsedUser = JSON.parse(storedUser);

  /*
   * Load the latest profile information
   * directly from the database.
   */
  let databaseUser = null;

  try {
    const response = await getProfile(parsedUser.username);

    if (
      response &&
      response.success &&
      response.user
    ) {
      databaseUser = response.user;
    }
  } catch (error) {
    console.error(
      "Failed to load profile from database:",
      error
    );
  }

  /*
   * Combine database information with
   * the locally stored account information.
   */
  const updatedUser = {
    ...parsedUser,
    ...(databaseUser || {}),

    username:
      databaseUser?.username ||
      parsedUser.username ||
      "",

    email:
      databaseUser?.email ||
      parsedUser.email ||
      "",

    created_at:
      databaseUser?.created_at ||
      parsedUser.created_at ||
      null,

    /*
     * Member Since uses the database
     * created_at field.
     */
    joinedAt:
      databaseUser?.created_at ||
      parsedUser.created_at ||
      parsedUser.joinedAt ||
      null,

    /*
     * Your current database does not have
     * last_login, so this safely checks
     * both possible values.
     */
    lastLogin:
      databaseUser?.last_login ||
      parsedUser.last_login ||
      parsedUser.lastLogin ||
      null,
  };

  setUserData(updatedUser);

  /*
   * Keep localStorage updated with the
   * latest database information.
   */
  localStorage.setItem(
    "user",
    JSON.stringify(updatedUser)
  );

  /*
   * Load Discord / YouTube / Website links.
   */
  try {
    const linksResponse = await getAccountLinks(
      updatedUser.username
    );

    if (
      linksResponse &&
      linksResponse.success &&
      linksResponse.accounts
    ) {
      setAccountLinks({
        discord:
          linksResponse.accounts.discord || "",

        youtube:
          linksResponse.accounts.youtube || "",

        website:
          linksResponse.accounts.website || "",
      });
    }
  } catch (error) {
    console.error(
      "Failed to load account links:",
      error
    );
  } finally {
    setLoadingLinks(false);
  }
} catch (error) {
  console.error(
    "Failed to load profile:",
    error
  );

  setLoadingLinks(false);
} finally {
  setLoading(false);
}


};

/*

* MySQL date:
*
* 2025-10-20 17:04:44
*
* Displays:
*
* 20 October 2025
  */
  const formatDate = (date) => {
  if (!date) {
  return "Not available";
  }


const value = String(date).trim();



const match = value.match(
  /^(\d{4})-(\d{2})-(\d{2})/
);

if (!match) {
  return "Not available";
}

const year = Number(match[1]);
const month = Number(match[2]);
const day = Number(match[3]);

const parsedDate = new Date(
  year,
  month - 1,
  day
);

if (Number.isNaN(parsedDate.getTime())) {
  return "Not available";
}

return parsedDate.toLocaleDateString(
  "en-GB",
  {
    day: "numeric",
    month: "long",
    year: "numeric",
  }
);


};

/*

* MySQL datetime:
*
* 2026-09-13 16:42:00
*
* Displays:
*
* 13 Sept 2026, 16:42
  */
  const formatDateTime = (date) => {
  if (!date) {
  return "Not available";
  }


const value = String(date).trim();



const match = value.match(
  /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?/
);

if (!match) {
  return "Not available";
}

const year = Number(match[1]);
const month = Number(match[2]);
const day = Number(match[3]);

const hour = Number(match[4]);
const minute = Number(match[5]);
const second = Number(match[6] || 0);

const parsedDate = new Date(
  year,
  month - 1,
  day,
  hour,
  minute,
  second
);

if (Number.isNaN(parsedDate.getTime())) {
  return "Not available";
}

return parsedDate.toLocaleString(
  "en-GB",
  {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }
);


};

/*

* Open Discord / YouTube / Website links.
  */
  const openLink = (url) => {
  if (!url) {
  return;
  }


let finalUrl = String(url).trim();



if (
  !finalUrl.startsWith("http://") &&
  !finalUrl.startsWith("https://")
) {
  finalUrl = `https://${finalUrl}`;
}

window.open(
  finalUrl,
  "_blank",
  "noopener,noreferrer"
);


};

/*

* Logout.
  */
  const handleLogout = () => {
  localStorage.removeItem("user");


window.location.href = "/login";


};

/*

* Loading screen.
  */
  if (loading) {
  return (

   <div className="profile-page">

     <div className="profile-loading">

  
   <i className="fas fa-spinner fa-spin"></i>

   <span>
     Loading profile...
   </span>
  

     </div>

   </div>


);


}

/*

* User isn't logged in.
  */
  if (!userData) {
  return (

   <div className="profile-page">

     <div className="profile-empty">

  
   <div className="profile-empty-icon">
     <i className="fas fa-user"></i>
   </div>

   <h2>
     No Profile Found
   </h2>

   <p>
     You need to be logged in to view
     your profile.
   </p>

   <Link
     to="/login"
     className="profile-login-button"
   >
     <i className="fas fa-sign-in-alt"></i>

     Login
   </Link>
  

     </div>

   </div>


);


}

/*

* Basic account information.
  */
  const username =
  userData.username || "User";

const email =
userData.email || "No email";

const rank =
userData.rank || "Member";

/*

* Avatar.
  */
  const defaultAvatar =
  `https://ui-avatars.com/api/?name=${encodeURIComponent(
   username
      )}&background=0b1220&color=00d9ff&bold=true`;

const avatar =
userData.avatar || defaultAvatar;

/*

* These values aren't currently in the
* database screenshot, so safely default
* them to zero / unavailable.
  */
  const uploads =
  Number(userData.uploads || 0);

const views =
Number(userData.views || 0);

const coins =
Number(userData.coins || 0);

const playtime =
userData.playtime || "0h";

return ( <div className="profile-page">


  {/* =========================================
      PROFILE HERO
  ========================================= */}

  <section className="profile-hero">

    <div className="profile-avatar-wrapper">

      <img
        src={avatar}
        alt={`${username} avatar`}
        className="profile-avatar"
        onError={(event) => {
          event.currentTarget.src =
            defaultAvatar;
        }}
      />

      <div className="profile-online-indicator"></div>

    </div>


    <div className="profile-hero-info">

      <h1>
        {username}
      </h1>

      <p className="profile-email">

        <i className="fas fa-envelope"></i>

        {email}

      </p>


      <span className="profile-rank">

        <i className="fas fa-shield-alt"></i>

        {rank}

      </span>

    </div>

  </section>


  {/* =========================================
      ACCOUNT INFORMATION
  ========================================= */}

  <section className="profile-card">

    <div className="profile-card-header">

      <div>

        <h2>

          <i className="fas fa-user-circle"></i>

          Account Information

        </h2>

        <p>
          Your Vortex Network account information.
        </p>

      </div>

    </div>


    <div className="profile-info-grid">

      {/* Username */}

      <div className="profile-info-item">

        <div className="profile-info-icon">

          <i className="fas fa-user"></i>

        </div>

        <div>

          <span className="profile-info-label">
            Username
          </span>

          <strong>
            {username}
          </strong>

        </div>

      </div>


      {/* Email */}

      <div className="profile-info-item">

        <div className="profile-info-icon">

          <i className="fas fa-envelope"></i>

        </div>

        <div>

          <span className="profile-info-label">
            Email Address
          </span>

          <strong>
            {email}
          </strong>

        </div>

      </div>


      {/* Member Since */}

      <div className="profile-info-item">

        <div className="profile-info-icon">

          <i className="fas fa-calendar-alt"></i>

        </div>

        <div>

          <span className="profile-info-label">
            Member Since
          </span>

          <strong>
            {formatDate(
              userData.joinedAt
            )}
          </strong>

        </div>

      </div>


      {/* Last Login */}

      <div className="profile-info-item">

        <div className="profile-info-icon">

          <i className="fas fa-clock"></i>

        </div>

        <div>

          <span className="profile-info-label">
            Last Login
          </span>

          <strong>
            {formatDateTime(
              userData.last_login
            )}
          </strong>

        </div>

      </div>

    </div>

  </section>


  {/* =========================================
      STATISTICS
  ========================================= */}

  <section className="profile-card">

    <div className="profile-card-header">

      <div>

        <h2>

          <i className="fas fa-chart-bar"></i>

          Statistics

        </h2>

        <p>
          Your activity across Vortex Network.
        </p>

      </div>

    </div>


    <div className="profile-stats-grid">

      {/* Uploads */}

      <div className="profile-stat">

        <div className="profile-stat-icon">

          <i className="fas fa-upload"></i>

        </div>

        <div>

          <strong>
            {uploads.toLocaleString()}
          </strong>

          <span>
            Uploads
          </span>

        </div>

      </div>


      {/* Views */}

      <div className="profile-stat">

        <div className="profile-stat-icon">

          <i className="fas fa-eye"></i>

        </div>

        <div>

          <strong>
            {views.toLocaleString()}
          </strong>

          <span>
            Views
          </span>

        </div>

      </div>


      {/* Coins */}

      <div className="profile-stat">

        <div className="profile-stat-icon">

          <i className="fas fa-coins"></i>

        </div>

        <div>

          <strong>
            {coins.toLocaleString()}
          </strong>

          <span>
            Coins
          </span>

        </div>

      </div>

    </div>

  </section>


  {/* =========================================
      SERVER INFORMATION
  ========================================= */}

  <section className="profile-card">

    <div className="profile-card-header">

      <div>

        <h2>

          <i className="fas fa-server"></i>

          Server Information

        </h2>

        <p>
          Your Vortex Network server information.
        </p>

      </div>

    </div>


    <div className="profile-info-grid">

      {/* Rank */}

      <div className="profile-info-item">

        <div className="profile-info-icon">

          <i className="fas fa-crown"></i>

        </div>

        <div>

          <span className="profile-info-label">
            Rank
          </span>

          <strong>
            {rank}
          </strong>

        </div>

      </div>


      {/* Playtime */}

      <div className="profile-info-item">

        <div className="profile-info-icon">

          <i className="fas fa-gamepad"></i>

        </div>

        <div>

          <span className="profile-info-label">
            Playtime
          </span>

          <strong>
            {playtime}
          </strong>

        </div>

      </div>

    </div>

  </section>


  {/* =========================================
      CONNECTED ACCOUNTS
  ========================================= */}

  <section className="profile-card">

    <div className="profile-card-header">

      <div>

        <h2>

          <i className="fas fa-link"></i>

          Connections

        </h2>

        <p>
          Your connected social accounts and websites.
        </p>

      </div>

    </div>


    <div className="profile-connections">

      {/* Discord */}

      <div className="profile-connection">

        <div className="profile-connection-icon discord">

          <i className="fab fa-discord"></i>

        </div>

        <div className="profile-connection-info">

          <span>
            Discord
          </span>

          {loadingLinks ? (

            <small>

              <i className="fas fa-spinner fa-spin"></i>

              Loading...

            </small>

          ) : accountLinks.discord ? (

            <button
              type="button"
              className="profile-link-button"
              onClick={() =>
                openLink(
                  accountLinks.discord
                )
              }
            >
              {accountLinks.discord}
            </button>

          ) : (

            <small className="not-connected">
              Not linked
            </small>

          )}

        </div>

      </div>


      {/* YouTube */}

      <div className="profile-connection">

        <div className="profile-connection-icon youtube">

          <i className="fab fa-youtube"></i>

        </div>

        <div className="profile-connection-info">

          <span>
            YouTube
          </span>

          {loadingLinks ? (

            <small>

              <i className="fas fa-spinner fa-spin"></i>

              Loading...

            </small>

          ) : accountLinks.youtube ? (

            <button
              type="button"
              className="profile-link-button"
              onClick={() =>
                openLink(
                  accountLinks.youtube
                )
              }
            >
              {accountLinks.youtube}
            </button>

          ) : (

            <small className="not-connected">
              Not linked
            </small>

          )}

        </div>

      </div>


      {/* Website */}

      <div className="profile-connection">

        <div className="profile-connection-icon website">

          <i className="fas fa-globe"></i>

        </div>

        <div className="profile-connection-info">

          <span>
            Website
          </span>

          {loadingLinks ? (

            <small>

              <i className="fas fa-spinner fa-spin"></i>

              Loading...

            </small>

          ) : accountLinks.website ? (

            <button
              type="button"
              className="profile-link-button"
              onClick={() =>
                openLink(
                  accountLinks.website
                )
              }
            >
              {accountLinks.website}
            </button>

          ) : (

            <small className="not-connected">
              Not set
            </small>

          )}

        </div>

      </div>

    </div>

  </section>


  {/* =========================================
      PROFILE ACTIONS
  ========================================= */}

  <section className="profile-actions">

    <Link
      to="/settings"
      className="profile-action-button"
    >

      <i className="fas fa-cog"></i>

      Account Settings

    </Link>


    <button
      type="button"
      className="profile-action-button logout"
      onClick={handleLogout}
    >

      <i className="fas fa-sign-out-alt"></i>

      Logout

    </button>

  </section>

</div>


);
}
